import { HttpClient } from "@angular/common/http";
import { Injectable, NgZone } from "@angular/core";
import * as actions from "@core/store/actions/location.action";
import { environment } from "@environments/environment";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";

@Injectable()
export class LocationService {
  constructor(private ngZone: NgZone, private http: HttpClient, private store: Store) {}

  public getPlaceDetails(placeId: string, retailerId: number): void {
    this.http
      .get<any>(
        `${environment.gateway.base_url}${environment.gateway.location_gateway_prefix}place-details?placeid=${placeId}&source=locationservices&retailer-id=${retailerId}`,
        { headers: { "retailer-id": retailerId + "" } }
      )
      .subscribe(response => {
        this.store.dispatch(actions.setDetailResponse({ details: response }));
      });
  }

  public getAutocompleteSuggestions(input: string, lat: number, lng: number, retailerId: number): Observable<any> {
    return this.http.get<any>(
      `${environment.gateway.base_url}${
        environment.gateway.location_gateway_prefix
      }autocomplete?lat=${lat}&lng=${lng}&text=${encodeURIComponent(input)}&source=locationservices`,
      {
        headers: { "retailer-id": retailerId + "" },
      }
    );
  }

  public listenAutoComplete(element: HTMLInputElement, anchorCoordinates: { lat: number; lng: number }, retailerId: number): void {
    element.addEventListener("input", (event: any) => {
      this.ngZone.run(async () => {
        this.store.dispatch(actions.uiLocation({ ui: [{ name: "loadingResults", value: true }] }));
        this.store.dispatch(
          actions.getAutocompleteResponses({
            input: event.target.value,
            lat: anchorCoordinates.lat,
            lng: anchorCoordinates.lng,
            retailerId,
          })
        );
      });
    });
  }

  public resetAutocompleteData(): void {
    this.store.dispatch(actions.clearAll());
  }
}
